var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionExitGray = function SvgGeneralActionExitGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "m19.19 3.75-7.206 7.192-7.173-7.16L3.75 4.84 10.924 12 3.75 19.159l1.06 1.058 7.173-7.159 7.205 7.192 1.061-1.059L13.045 12l7.206-7.192z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralActionExitGray;